import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-role",
  "use": "icon-role-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" class=\"icon\" id=\"icon-role\">\r\n\r\n  <path id=\"icon-role_角色\" class=\"cls-1\" d=\"M39,706.276a5.642,5.642,0,1,1,5.576-5.642A5.616,5.616,0,0,1,39,706.276Zm0-10.23a4.588,4.588,0,1,0,4.535,4.588A4.567,4.567,0,0,0,39,696.046ZM39,713H31.525A0.524,0.524,0,0,1,31,712.469c0-4,3.587-7.247,8-7.247a0.527,0.527,0,0,1,0,1.054c-3.635,0-6.627,2.5-6.928,5.666H39A0.528,0.528,0,0,1,39,713Zm7.474-2.746H42.631a0.527,0.527,0,0,1,0-1.054h3.842A0.527,0.527,0,0,1,46.473,710.251Zm0-2.4H42.631a0.527,0.527,0,0,1,0-1.054h3.842A0.527,0.527,0,0,1,46.473,707.848Zm0,4.806H42.631a0.528,0.528,0,0,1,0-1.055h3.842A0.528,0.528,0,0,1,46.473,712.654Z\" transform=\"translate(-31 -695)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/role.svg
// module id = cqqK
// module chunks = 127